import React from "react";
import SvgSprite from "championship/src/components/Utils/SvgSprite";

class TextField extends React.Component{
    render(){
        const that = this
        return (
            <div>
                <div class="js-form-field__wrapper">
                    <div class="js-form-field__text">
                        <input type="text" readonly="" />
                        <input 
                            type="date" 
                            name={this.props.name}
                            id={this.props.id}

                            // defaultValue={this.props.value}
                            max={this.props.max}
                            required={this.props.required}
                            />
                    </div>
                    <div class="js-form-field__icon">
                        <SvgSprite id="date" section="form"/>
                    </div>
                </div>
                <div class="form-field-popup calendar-popup"></div>
            </div>
        )
    }
}

export default TextField